module.exports = __webpack_public_path__ + "img/white_logo-guadalajara.f8875dbb.svg";